const getStatusConfig = (status) => {
  const s = status?.toUpperCase() || "";

  const colors = {
    approval: {
      bg: "#EFF6FF",
      text: "#1E40AF",
      icon: "#1E40AF",
      border: "#BFDBFE"
    },
    warning: {
      bg: "#FFF7ED",
      text: "#B45309",
      icon: "#B45309",
      border: "#FED7AA"
    },
    success: {
      bg: "#ECFDF3",
      text: "#027A48",
      icon: "#027A48",
      border: "#A6F4C5"
    },
    danger: {
      bg: "#FEF3F2",
      text: "#B42318",
      icon: "#B42318",
      border: "#FECDCA"
    },
    neutral: {
      bg: "#F2F4F7",
      text: "#344054",
      icon: "#344054",
      border: "#D0D5DD"
    }
  };

  const configs = {
    AWAITING_APPROVAL: {
      ...colors.approval,
      icon: "pending_actions"
    },

    AWAITING_RELEASE: {
      ...colors.warning,
      icon: "schedule_send"
    },
    AWAITING_PROMOTION: {
      ...colors.warning,
      icon: "hourglass_top"
    },

    RELEASED: {
      ...colors.success,
      icon: "rocket_launch"
    },

    PROMOTED: {
      ...colors.approval,
      icon: "arrow_upward"
    },

    REJECTED: {
      ...colors.danger,
      icon: "cancel"
    },

    FAILED: {
      ...colors.danger,
      icon: "cancel"
    },

    DEFAULT: {
      ...colors.neutral,
      icon: "help_outline"
    }
  };

  return configs[s] || configs.DEFAULT;
};

const getActionBadgeConfig = (action) => {
  switch (action) {
    case "APPROVE":
      return { icon: "check_circle", color: "#36B37E" };
    case "REJECT":
      return { icon: "cancel", color: "#DE350B" };
    default:
      return null;
  }
};

const getTypeIcon = (type) => {
  switch (type) {
    case "USER":
      return "person";
    case "GROUP":
      return "group";
    case "ROLE":
      return "admin_panel_settings";
    case "ANYONE":
      return "public";
    default:
      return "help_outline";
  }
};

export { getStatusConfig, getActionBadgeConfig, getTypeIcon };
